import "./AnodizedAluminum.module.css";
import Header from "@/reusable_sections/Header";
import PageHeader from "./sections/PageHeader";
import DirectAnswerBlock from "./sections/DirectAnswerBlock";
import WhatIsAnodizedAluminum from "./sections/WhatIsAnodizedAluminum";
import ColorsAndFinishes from "./sections/ColorsAndFinishes";
import AnodizedAluminumProperties from "./sections/AnodizedAluminumProperties";
import WhenToChooseAnodizedAluminum from "./sections/WhenToChooseAnodizedAluminum";
import WhereAnodizedAluminumIsUsed from "./sections/WhereAnodizedAluminumIsUsed";
import FaqAccordion from "./sections/FaqAccordion";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function AnodizedAluminumPage() {
  return <div>
      <Header />
      <PageHeader />
      <DirectAnswerBlock />
      <WhatIsAnodizedAluminum />
      <ColorsAndFinishes />
      <AnodizedAluminumProperties />
      <WhenToChooseAnodizedAluminum />
      <WhereAnodizedAluminumIsUsed />
      <FaqAccordion />
      <ClosingCta />
      <Footer />
    </div>;
}